import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const { t } = useLanguage();
  const [form, setForm] = useState({
    name: '',
    surname: '',
    nickName: '',
    email: '',
    password: '',
    userImage: null,
    termsAccepted: false,
  });
  const [error, setError] = useState('');

  const handleChange = (event) => {
    const { name, value, type, checked, files } = event.target;
    if (type === 'file') {
      setForm((prev) => ({ ...prev, userImage: files[0] }));
      return;
    }
    setForm((prev) => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    try {
      await register(form);
      navigate('/feed');
    } catch (err) {
      setError(err?.response?.data?.message || t('auth.registerError'));
    }
  };

  return (
    <div className="card" style={{ maxWidth: 560, margin: '0 auto' }}>
      <h2 className="section-title">{t('auth.registerTitle')}</h2>
      <p className="section-subtitle">{t('auth.registerDesc')}</p>
      <form onSubmit={handleSubmit} className="grid two-col" style={{ marginTop: 24 }}>
        <div>
          <label className="muted">{t('auth.name')}</label>
          <input className="input" name="name" value={form.name} onChange={handleChange} required />
        </div>
        <div>
          <label className="muted">{t('auth.surname')}</label>
          <input className="input" name="surname" value={form.surname} onChange={handleChange} required />
        </div>
        <div>
          <label className="muted">{t('auth.username')}</label>
          <input className="input" name="nickName" value={form.nickName} onChange={handleChange} required />
        </div>
        <div>
          <label className="muted">{t('auth.email')}</label>
          <input className="input" type="email" name="email" value={form.email} onChange={handleChange} required />
        </div>
        <div>
          <label className="muted">{t('auth.password')}</label>
          <input className="input" type="password" name="password" value={form.password} onChange={handleChange} required />
        </div>
        <div>
          <label className="muted">{t('auth.photo')}</label>
          <input className="input" type="file" name="userImage" onChange={handleChange} required />
        </div>
        <div style={{ gridColumn: '1 / -1' }}>
          <label style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
            <input type="checkbox" name="termsAccepted" checked={form.termsAccepted} onChange={handleChange} required />
            <span className="muted">{t('auth.terms')}</span>
          </label>
        </div>
        {error ? <p style={{ color: 'var(--danger)', gridColumn: '1 / -1' }}>{error}</p> : null}
        <div style={{ gridColumn: '1 / -1' }}>
          <button className="btn btn-primary" type="submit">
            {t('actions.register')}
          </button>
        </div>
      </form>
    </div>
  );
}
